import { SyntheticEvent, useState } from 'react';
import ZoomableImage from 'components/ZoomableImage';

interface ImageProps {
    url?: string | null;
}

const Image = ({ url }: ImageProps) => {
    const [dimensions, setDimensions] = useState({
        height: 172,
        width: 212,
    });
    const { height, width } = dimensions;

    return (
        <ZoomableImage
            src={url || ''}
            alt=""
            width={width}
            height={height}
            onLoad={(event: SyntheticEvent<HTMLImageElement>) => {
                const target = event.target as HTMLImageElement;
                setDimensions({
                    width: target.offsetWidth,
                    height: target.offsetHeight,
                });
            }}
        />
    );
};

export default Image;
